import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Alert, AlertService } from '@michelin/theme';
import { AutomakerDto } from 'src/app/shared/models/automaker/automaker-dto';
import { StateDto } from 'src/app/shared/models/location/state-dto';
import { ProductLineDto } from 'src/app/shared/models/product-line/product-line-dto';
import { DealershipFormComponent } from '../components/dealership-form/dealership-form.component';
import { LocationService } from 'src/app/shared/services/location/location.service';
import { ProductLineService } from 'src/app/shared/services/product-line/product-line.service';
import { DealershipDto } from 'src/app/shared/models/dealership/dealership-dto';
import { DealershipService } from 'src/app/shared/services/dealership/dealership.service';
import { AutomakerService } from 'src/app/shared/services/automaker/automaker.service';
import { DistributorService } from 'src/app/shared/services/distributor/distributor.service';

@Component({
    selector: 'app-update-dealership',
    templateUrl: './update-dealership.component.html',
    standalone: false
})
export class UpdateDealershipComponent implements OnInit {
  loading: boolean = false;
  dealershipId: number = 0;

  data = {
    automakers: [] as AutomakerDto[],
    states: [] as StateDto[],
    productLines: [] as ProductLineDto[],
    dealership: {} as DealershipDto
  };

  @ViewChild(DealershipFormComponent) delaershipForm: DealershipFormComponent;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly alertService: AlertService,
    private readonly dealershipService: DealershipService,
    private readonly automakerService: AutomakerService,
    private readonly distrubutorService: DistributorService,
    private readonly locationService: LocationService,
    private readonly productLineService: ProductLineService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.dealershipId = this.activatedRoute.snapshot.params['id'];

    forkJoin({
      automakers: this.automakerService.findAll(),
      states: this.locationService.findAllStates(),
      productLines: this.productLineService.findAll(),
      dealership: this.dealershipService.findById(this.dealershipId)
    }).subscribe({
      next: (result) => (this.data = result),
      complete: () => {
        this.distrubutorService
          .findByCityIdAndProductLine(this.data.dealership?.company?.address?.city?.id, this.data.dealership?.productLine?.id)
          .subscribe({
            next: (distributor) => (this.data.dealership.distributor = distributor),
            complete: () => {
              this.delaershipForm.loadFormValues(this.data.dealership);
            }
          })
          .add(() => (this.loading = false));
      }
    });
  }

  submitForm() {
    this.loading = true;
    this.dealershipService
      .update(this.dealershipId, this.delaershipForm.formValues)
      .subscribe({
        next: () =>
          this.alertService.showAlert({
            type: 'success',
            content: 'Concessionária atualizada com sucesso'
          } as Alert),
        error: () => {
          this.alertService.showAlert({
            type: 'critical',
            content: 'Ocorreu um erro ao atualizar a concessionária'
          } as Alert);
        }
      })
      .add(() => (this.loading = false));
  }
}
